module.exports = __webpack_public_path__ + "img/RORBPJR40046.cfe22cc5.png";